import { SimpleErrorModal } from 'ii-react-sdk/modal_components';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useComparison } from '../../provider';
import prepareClassifications from './actions/prepareClassifications';
const GridContext = createContext({});
const GridProvider = (props) => {
    const { commentId } = useParams();
    const { comparisonDocuments, anchorDocId } = useComparison();
    const [isGridLoading, setIsGridLoading] = useState(true);
    const [anchorDoc, setAnchorDoc] = useState({});
    const [comparatorDocs, setComparatorDocs] = useState([]);
    const [tagsColumn, setTagsColumn] = useState([]);
    const [filteredTagsColumn, setFilteredTagsColumn] = useState([]);
    const [categories, setCategories] = useState([]);
    const [descriptors, setDescriptors] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedDescriptors, setSelectedDescriptors] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const [anchorDocTabIndex, setAnchorDocTabIndex] = useState({});
    const [modalDocument, setModalDocument] = useState();
    const [isDocModalOpen, setIsDocModalOpen] = useState(false);
    const [docBookmark, setDocBookmark] = useState([]);
    const [areChecklistItemsVisible, setAreChecklistItemsVisible] = useState(true);
    const [areCommentsVisible, setAreCommentsVisible] = useState(!!(commentId));
    const [isErrorModalShowing, setIsErrorModalShowing] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState('');
    useEffect(() => {
        try {
            if (!comparisonDocuments.length || anchorDocId === undefined)
                return;
            setIsGridLoading(true);
            const anchor = comparisonDocuments.find(d => d.fileId === anchorDocId);
            if (!anchor)
                return;
            setAnchorDoc(anchor);
            const comparatorDocuments = comparisonDocuments.filter(d => d.fileId !== anchorDocId);
            setComparatorDocs(comparatorDocuments);
            const preparedInfo = prepareClassifications(anchor, comparatorDocuments);
            setCategories(preparedInfo.categories);
            setSelectedCategories(preparedInfo.categories);
            setDescriptors(preparedInfo.descriptors);
            setSelectedDescriptors(preparedInfo.descriptors);
            setTagsColumn(preparedInfo.tagsColumn);
            setIsGridLoading(false);
        }
        catch (e) {
            console.error(e);
            setErrorModalMessage(e.message);
            setIsErrorModalShowing(true);
        }
    }, [comparisonDocuments, anchorDocId]);
    useEffect(() => {
        const filteredTagsColumn = [];
        for (const c of tagsColumn) {
            const matchCat = !!(!selectedCategories.length || selectedCategories.includes(c.category.display));
            const matchDes = !!(!selectedDescriptors.length || selectedDescriptors.includes(c.descriptor.display));
            if (matchCat && matchDes)
                filteredTagsColumn.push(c);
        }
        setFilteredTagsColumn(filteredTagsColumn);
    }, [tagsColumn, selectedCategories, selectedDescriptors]);
    const value = {
        isGridLoading,
        anchorDoc,
        setAnchorDoc,
        comparatorDocs,
        setComparatorDocs,
        filteredTagsColumn,
        categories,
        descriptors,
        selectedCategories,
        setSelectedCategories,
        selectedDescriptors,
        setSelectedDescriptors,
        selectedRowIndex,
        setSelectedRowIndex,
        anchorDocTabIndex,
        setAnchorDocTabIndex,
        modalDocument,
        setModalDocument,
        isDocModalOpen,
        setIsDocModalOpen,
        docBookmark,
        setDocBookmark,
        areChecklistItemsVisible,
        setAreChecklistItemsVisible,
        areCommentsVisible,
        setAreCommentsVisible,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(GridContext.Provider, Object.assign({ value: value }, props)),
        React.createElement(SimpleErrorModal, { isModalShowing: isErrorModalShowing, errorMessage: errorModalMessage }));
};
const useGrid = () => {
    const ctx = useContext(GridContext);
    if (ctx === undefined) {
        throw new Error('GridContext can only be used under the GridProvider');
    }
    return ctx;
};
export { useGrid, GridProvider, };
